import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Input from "../Components/Input";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faTrash } from "@fortawesome/free-solid-svg-icons";
import useApi from "../Api/Api";
import Button from "../Components/Button";
import AddUser from "../Forms/AddUser";
import UsersLayout from "./UsersLayout";

const Users = () => {
  const api = useApi();
  const [users, setUsers] = useState([]);
  const [showForm, setShowForm] = useState(false);

  const handleShowForm = () => {
    setShowForm(!showForm);
  };

  const [searchFilter, setSearchFilter] = useState();

  const [searchTimeout, setSearchTimeout] = useState();

  const handleSearchChange = (e) => {
    setSearchTimeout(e.target.value);
  };

  useEffect(() => {
    const delaySearch = setTimeout(() => {
      setSearchFilter(searchTimeout);
    }, 500);

    return () => clearTimeout(delaySearch);
  }, [searchTimeout, setSearchFilter]);

  const getUsers = useCallback(() => {
    let queryParams = {};
    if (searchFilter) {
      queryParams.query = searchFilter;
    }
    const queryString = Object.keys(queryParams)
      .map((param) => `${param}=${queryParams[param]}`)
      .join("&");
    api.get(`/users?${queryString}`).then((r) => {
      setUsers(r.data);
    });
  }, [api, setUsers, searchFilter]);

  useEffect(() => {
    getUsers();
  }, [getUsers]);

  const deleteUser = (e, userToDelete) => {
    e.preventDefault();
    const check = window.confirm(
      `Are you sure you want to delete ${userToDelete.email}?`
    );
    if (check) {
      api.delete(`users/${userToDelete.id}`).then(() => {
        getUsers();
      });
    }
  };

  return (
    <UsersLayout>
      <div className="text-black bg-gray-100 pt-2 pb-8">
        {showForm && (
          <AddUser
            handleShowForm={handleShowForm}
            getUsers={getUsers}
          ></AddUser>
        )}
        <div className={showForm ? "blur" : ""}>
          <div className="mt-8 mx-8 py-10 px-12 text-black bg-white rounded-lg border">
            <div className="flex justify-end text-sm">
              {!showForm && (
                <Button
                  onClick={handleShowForm}
                  className="button"
                  text="New user"
                ></Button>
              )}
            </div>
            <div
              className={
                showForm
                  ? "pt-5 text-2xl pb-10 font-medium"
                  : "text-2xl -mt-4 pb-10 font-medium"
              }
            >
              User Listing
            </div>
            <div className="absolute mt-2 ml-2 text-black">
              <FontAwesomeIcon icon={faSearch}></FontAwesomeIcon>
            </div>
            <div className="w-1/2 mr-2 text-sm">
              <Input
                onChange={handleSearchChange}
                value={searchTimeout}
                placeholder="Search for users"
                bigPaddingLeft
              />
            </div>
            <table>
              <thead>
                <tr>
                  <td className="w-1/3"></td>
                  <td className="w-1/3"></td>
                  <td className="w-1/3"></td>
                </tr>
              </thead>
              <tbody>
                {users.map((user) => (
                  <tr key={user.id} className="border-b pt-8 pb-7 text-sm h-20">
                    <td>{user.role.charAt(0).toUpperCase() + user.role.slice(1)}</td>
                    <td>
                      <Link to={`/users/${user.id}`}>{user.email} </Link>
                    </td>
                    <td className="text-right">
                      <button onClick={(e) => deleteUser(e, user)}>
                        <FontAwesomeIcon icon={faTrash}></FontAwesomeIcon>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </UsersLayout>
  );
};

export default Users;
